<script lang="ts">
    import MessageList from "./message/MessageList.svelte";
    import iconStore from "./store/iconStore";
    import type {Icon} from "./@type";
    import IconListButton from "./parts/IconListButton.svelte";
    import {Modal} from "svelte-simple-modal";

    let testMessage: Message[] = [
        {
            id: "1",
            name: "NsR: 東野 あさみ",
            speaker: "NsR-1",
            body: "「夜天光研究団井雲研究所へようこそ。実験については、このあと研究主任の吉里から説明させて頂きます。」",
            turn: 1,
            icon: {
                id: "1",
                speaker: "NsR-1",
                url: "./icon/1.png"
            },
            date: (new Date()).toLocaleString()
        }, {
            id: "2",
            name: "NsR: 東野 あさみ",
            speaker: "NsR-1",
            body: "「説明会の前に、こちらの機密保持契約書および実験参加誓約書への署名をお願い致します。」",
            turn: 1,
            icon: {
                id: "1",
                speaker: "NsR-1",
                url: "./icon/1.png"
            },
            date: (new Date()).toLocaleString()
        }, {
            id: "3",
            name: "機密保持契約書",
            speaker: "NsR-2",
            body: "実験中に見聞きした論文査読前の科学理論、研究団の人事情報、実験設備の写真、吉里博士が舌を噛んだ回数、およびそのほか帝国法に基づき企業機密として指定される事項を実験外へ漏洩した場合、八大企業連合軍による拘束および強制雇用が執行されることに同意します。" +
                "\n\nなんてことが書かれている。",
            turn: 1,
            icon: {
                id: "2",
                speaker: "NsR-2",
                url: "./icon/2.png"
            },
            metadata: {
                bodyClass: "letter"
            },
            date: (new Date()).toLocaleString()
        }, {
            id: "4",
            name: "誓約書",
            speaker: "NsR-2",
            body: "本実験中に被験者に発生した損害について、予め規定された実験協力金以外に、研究団が一切の補償を行わないことに同意し、請求を行わないことに同意します。",
            turn: 1,
            icon: {
                id: "2",
                speaker: "NsR-2",
                url: "./icon/2.png"
            },
            metadata: {
                bodyClass: "letter"
            },
            date: (new Date()).toLocaleString()
        }
    ];

    let initIcons = [
        {url: "./icon/1.png", speaker: "1", id: "1", order: 1, name: "サンプル1"},
        {url: "./icon/2.png", speaker: "1", id: "2", order: 2, name: "夜天光研究団"},
        {url: "./icon/3.png", speaker: "1", id: "3", order: 3, name: "サンプル3"},
        {url: "./icon/4.png", speaker: "1", id: "4", order: 4, name: "サンプル4"},
        {url: "./icon/5.png", speaker: "1", id: "5", order: 5, name: "サンプル5"},
        {url: "./icon/6.png", speaker: "1", id: "6", order: 6, name: "サンプル6"},
        {url: "./icon/7.png", speaker: "1", id: "7", order: 7, name: "サンプル7"},
        {url: "./icon/8.png", speaker: "1", id: "8", order: 8, name: "サンプル8"},
        {url: "./icon/9.png", speaker: "1", id: "9", order: 9, name: "サンプル9"},
        {url: "./icon/10.png", speaker: "1", id: "10", order: 10, name: "サンプル10"},
    ] as Icon[]
    iconStore.update(() => initIcons);
</script>

<main>
    <Modal classWindowWrap="model-wrap">
        <MessageList messages={testMessage} />
        <IconListButton/>
    </Modal>
</main>

<style>
</style>